<template>
    <div style="padding: 20px;">
      <el-row>
        <el-form>
          <el-form-item label-position="left" label-width="100px" label="选择规格：">
            <el-select style="width:200px;" v-model="mspecinfo" filterable placeholder="请选择需要添加的规格" height="120px" @change="specchange">
              <el-option
                v-for="(item,index) in mspecs"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button style="margin-left: 10px;" type="success" icon="el-icon-plus" @click="basespecmana">新增规格</el-button>
            <el-button v-if="spectbdataex.length > 0" type="primary" icon="el-icon-edit" @click="setprices">设定价格</el-button>
          </el-form-item>
          <el-row>
            <el-form>
              <el-form-item style="margin-bottom: 10px;" v-for="(spec,index) in speclist" :key="index">
                <el-card class="box-card">
                  <div slot="header" class="clearfix" style="display: flex;">
                    <span style="flex:1">{{spec.name}} (请选择参考值或者新增属性值)</span>
                    <span style="width: 50px; display: flex; align-items: center;
    font-size: 1.5em;">
                      <i @click="addspec(index)" class="el-icon-edit-outline" style="margin-right: 5px;"></i>
                      <i @click="closespec(index)" class="el-icon-close"></i>
                    </span>
                  </div>
                  <div>
                    参考值:
                    <el-tag
                      style="margin-left: 10px;"
                      v-for="(tag,tagindex) in spec.tags"
                      :key="tagindex"
                      @click.native="addoldtag(index,tag)"
                      type="success">
                      {{tag.attrvalue}}
                    </el-tag>
                  </div>
                  <div v-for="(subspec,subindex) in spec.items" :key="subindex" class="text item">
                    <el-row style="margin-bottom: 10px;">
                      <el-form-item>
                        <el-col :span="24">
                          <el-input :placeholder="'请输入:' + subspec.value" v-model="subspec.value">
                            <template slot="prepend">{{spec.name}}</template>
                            <el-button slot="append" @click="delspec(index,subindex)" icon="el-icon-close"></el-button>
                          </el-input>
                        </el-col>
                      </el-form-item>
                    </el-row>
                  </div>
                </el-card>
              </el-form-item>
              <el-button v-if="speclist.length > 0" type="primary" icon="el-icon-edit" @click="savespecs" round>保存规格</el-button>
            </el-form>
          </el-row>
        </el-form>
      </el-row>
      <el-divider></el-divider>
      <div style="margin-bottom: 20px;">已分配规格：</div>
      <el-table
        :data="spectbdataex"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        fit>
        <el-table-column
          prop="attrname"
          label="属性名称"
        >
        </el-table-column>
        <el-table-column
          prop="attrvalue"
          label="属性值"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="50px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="删除产品规格" placement="top-start">
              <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delgoodsspec(scope.$index, spectbdataex)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="基础规格" :visible.sync="basespecvisible">
        <GSpecs @getattrs="getspecs"></GSpecs>
      </el-dialog>
      <el-dialog title="配置价格" :visible.sync="spricepanelvisible">
        <el-table
          stripe
          highlight-current-row
          :span-method="objectSpanMethod"
          :data ="specvaluesdata"
          ref="multipleTable">
          <el-table-column
            v-for="(col,i) in cols" :key="i" :prop="col.prop" :label="col.label" >
          </el-table-column>
          <el-table-column label="价格"
                           align="center"
                           width="180">
            <template slot-scope="scope">
              <el-input
                placeholder="请输入价格"
                v-model="scope.row.priceinfo" >
              </el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 10px;">
          <el-col :span="6">
            <el-input
              placeholder="请输入统一价格"
              v-model="allpricevalue" >
            </el-input>
          </el-col>
          <el-button style="margin-left:10px;" @click="setallprice">设定统计价格</el-button>
          <el-button style="margin-left:10px;" @click="saveallprice">保存规格价格</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="当前商品已添加规格" :visible.sync="specpanelvisible">
        <el-table
          :data="spectbdataex"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          fit>
          <el-table-column
            prop="attrname"
            label="属性名称"
          >
          </el-table-column>
          <el-table-column
            prop="attrvalue"
            label="属性值"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="50px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除产品规格" placement="top-start">
                <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delgoodsspec(scope.$index, spectbdataex)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import GSpecs from './GSpecs'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'MSpecs',
    components: {
      GSpecs
    },
    data () {
      return {
        mspecs: [],
        mspecinfo: '',
        speclist: [],
        specvaluesdata: [],
        spectbdataex: [],
        cols: [],
        specidsdata: [],
        cktype: true,
        tcardtypes: [{
          value: '1',
          label: '年卡'
        }, {
          value: '2',
          label: '季卡'
        }, {
          value: '3',
          label: '双年卡'
        }],
        specgroupsdata: [],
        spricepanelvisible: false,
        basespecvisible: false,
        specpanelvisible: false,
        allpricevalue: ''
      }
    },
    mounted () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.getspecs()
        that.getdbspecs()
      }
    },
    methods: {
      basespecmana () {
        that.basespecvisible = true
      },
      getspecs () {
        var qstr = {
          whereinfo: 'ownphone = ' + localStorage.getItem('username') + ' and type=1',
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querbga',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.mspecs = res.data
              console.log(that.mspecs)
            } else {
              that.mspecs = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getdbspecs () {
        var qstr = {
          whereinfo: 'goods_id = ' + localStorage.getItem('curgoodsid') + ' and attrtype = 1',
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querbgav',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.spectbdataex = res.data
              localStorage.setItem('newgspecs',JSON.stringify(that.spectbdataex))
            } else {
              localStorage.setItem('newgspecs','[]')
              that.spectbdataex = []
            }
            that.$emit('reloaddata');
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      specchange (val) {
        console.log(val)
        var dataindex = this.mspecs.findIndex(d => d.id === val)
        var qstr = {
          whereinfo: 'attrid=' + parseInt(this.mspecs[dataindex].id) + " and attrvalue != '' and ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querbgs',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            var datatmp = []
            if (res.data.length > 0) {
              var tmpdata = res.data
              datatmp = tmpdata
            } else {
              datatmp = []
            }
            var adtmp = {
              id: that.mspecs[dataindex].id,
              name: that.mspecs[dataindex].name,
              tags: datatmp,
              items: []
            }
            that.speclist.push(adtmp)
            window.console.log('speclist',that.speclist)
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addoldtag (index,tag) {
        var adata = {
          value: tag.attrvalue
        }
        this.speclist[index].items.push(adata)
      },
      addspec (index) {
        var adata = {
          value: ''
        }
        this.speclist[index].items.push(adata)
      },
      closespec (index) {
        this.speclist.splice(index, 1)
      },
      delspec(index,subindex) {
        this.speclist[index].items.splice(subindex, 1)
      },
      delgoodsspec (index, data) {
        var curselectdata = data[index]
        console.log(curselectdata)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delbgav',
          method: 'post',
          data: {
            id: curselectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.getdbspecs()
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      savespecs () {
        var adatas = []
        for (var index in this.speclist) {
          var subdata = this.speclist[index]
          for (var subindex in subdata.items) {
            var subsubdata = subdata.items[subindex]
            var adata = {
              goods_id: localStorage.getItem('curgoodsid').toString(),
              attrid: subdata.id.toString(),
              attrtype: '1',
              attrname: subdata.name.toString(),
              attrvalue: subsubdata.value,
              cusid: that.khid.toString(),
              ownphone: localStorage.getItem('username')
            }
            adatas.push(adata)
          }
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/paddbgav',
          method: 'post',
          data: adatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.mspecs = []
              that.getdbspecs()
              that.$message({
                type: 'success',
                message: '保存规格成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      seespecs () {
        this.specpanelvisible = true
        that.$options.methods.getdbspecs()
      },
      setprices () {
        // 判断规格是否已经设置，如果设置了
        /*
        var ifttype = false
        var itype = localStorage.getItem('showgoodstype').split(',');

        var otype = []
        if (localStorage.getItem('ttypes') !== null && localStorage.getItem('ttypes') !== '') {
          otype = localStorage.getItem('ttypes').split(',');
        }
        for (var i = 0; i < itype.length; i++) {
          for (var j = 0; j < otype.length; j++) {
            if (itype[i] === otype[j]) {
              ifttype = true
            }
          }
        }
        window.console.log('是否为特殊分类')
        window.console.log(ifttype)
        that.cktype = ifttype
        */
        // 判断规格是否已经设置，如果设置了
        var qstr = {
          whereinfo: 'goods_id = ' + localStorage.getItem('curgoodsid') + ' and attrtype = 1',
          limit: '',
          sortinfo: ' group by attrid'
        }
        // var qstr = 'goods_id = ' + localStorage.getItem('curgoodsid') + ' and attrtype = 2  and cusid = ' + that.khid
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querbgav',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              var coltitledata = res.data
              window.console.log(coltitledata)
              // 填充动态表头
              that.cols = []
              for (var z=0; z<coltitledata.length; z++) {
                var adddata = {
                  prop: 'col' + z,
                  label: coltitledata[z].attrname
                }
                that.cols.push(adddata)
              }
              window.console.log(that.cols)
              // 开始获取动态列
              var qstr1 = {
                whereinfo: 'goods_id = ' + localStorage.getItem('curgoodsid') + ' and attrtype = 1',
                limit: '',
                sortinfo: ''
              }
              window.console.log('获取子规格数据',qstr1)
              that.$http({
                url: 'https://ecommapi.sqnetsoft.cn/querbgav',
                method: 'post',
                data: qstr1,
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.length > 0) {
                    var coldata = res.data
                    window.console.log(coldata)
                    // 填充动态表头
                    var tmpdata = []
                    var valuedatas = []
                    var iddatas = []
                    for (var i = 0; i < coltitledata.length; i++) {
                      var onelevel = {
                        attrname: coltitledata[i].attrname
                      }
                      var itemstmp = []
                      var subvaluestmp = []
                      var subidstmp = []
                      for (var j = 0; j < coldata.length; j++) {
                        if (coltitledata[i].attrid === coldata[j].attrid) {
                          var twolevel = {
                            attrname: coltitledata[i].attrname,
                            attrvalue: coldata[j].attrvalue
                          }
                          subidstmp.push(coldata[j].id)
                          subvaluestmp.push(coldata[j].attrvalue.replace(',',''))
                          itemstmp.push(twolevel)
                        }
                      }
                      if (subvaluestmp.length > 0) {
                        valuedatas.push(subvaluestmp)
                        iddatas.push(subidstmp)
                      }
                      onelevel.values = itemstmp
                      tmpdata.push(onelevel)
                    }
                    var finarr = doExchange(valuedatas)
                    var finidarr = doExchange(iddatas)
                    that.specidsdata = finidarr
                    that.specgroupsdata = tmpdata
                    window.console.log('specgroup 数据')
                    window.console.log(that.specgroupsdata)
                    window.console.log(finarr)
                    window.console.log(finidarr)
                    var datatmpx = []
                    for (var x = 0; x < finarr.length; x++) {
                      var tmpdatax = []
                      var finarrtmp = finarr[x]
                      tmpdatax = finarrtmp.split(',')
                      var adddatax = '{'
                      for (var c = 0; c < tmpdatax.length; c++) {
                        if (c === tmpdatax.length - 1) {
                          adddatax = adddatax + '"col' + c + '": "' + tmpdatax[c] + '"'
                        } else {
                          adddatax = adddatax + '"col' + c + '": "' + tmpdatax[c] + '",'
                        }
                      }
                      adddatax = adddatax + '}'
                      datatmpx.push(JSON.parse(adddatax))
                    }
                    window.console.log('拼装数据')
                    window.console.log(datatmpx)
                    that.getSpanData(datatmpx)
                    that.$options.methods.getallprice(datatmpx)
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        this.spricepanelvisible = true
      },
      getallprice: function (tmpdata) {
        var qstr = {
          whereinfo: 'goodsid = ' + localStorage.getItem('curgoodsid'),
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygprice',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              var curdatatmp = res.data
              console.log('价格数据')
              console.log(curdatatmp)
              for (var k = 0; k < tmpdata.length; k++) {
                console.log(that.specidsdata[k].toString())
                var priceinfo = ''
                var times = 0
                var tcardtype = ''
                for (var i = 0; i < curdatatmp.length; i++) {
                  if (that.specidsdata[k].toString() === curdatatmp[i].specgroupid) {
                    console.log('相同')
                    priceinfo = curdatatmp[i].saleprice
                    times = curdatatmp[i].times
                    tcardtype = curdatatmp[i].tcardtype.toString()
                  }
                }
                tmpdata[k].priceinfo = priceinfo
                tmpdata[k].times = times
                tmpdata[k].tcardtype = tcardtype
              }
              that.specvaluesdata = tmpdata
              console.log(that.specvaluesdata)
            } else {
              console.log('都还没设定价格')
              for (var z = 0; z < tmpdata.length; z++) {
                tmpdata[z].priceinfo = ''
                tmpdata[z].times = 0
                tmpdata[z].tcardtype = ''
              }
              that.specvaluesdata = tmpdata
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      setallprice: function () {
        if (this.allpricevalue !== '') {
          var findatatmp = []
          for (var k = 0; k < that.specvaluesdata.length; k++) {
            var datatmp = that.specvaluesdata[k]
            datatmp.priceinfo = this.allpricevalue
            findatatmp.push(datatmp)
          }
          that.specvaluesdata = findatatmp
        } else {
          that.$message({
            type: 'info',
            message: '请输入统一价格!'
          })
        }
      },
      saveallprice: function () {
        var idatas = []
        console.log(that.specnormaldata)
        console.log(that.specidsdata)
        for (var k = 0; k < that.specvaluesdata.length; k++) {
          var idata = {
            goodsid: localStorage.getItem('curgoodsid').toString(),
            specgroupid: that.specidsdata[k].toString(),
            cuserid: that.khid.toString(),
            buyprice: that.specvaluesdata[k].priceinfo.toString(),
            saleprice: that.specvaluesdata[k].priceinfo.toString(),
            baseprice: that.specvaluesdata[k].priceinfo.toString(),
            tcardtype: '',
            times: '',
            cusid: that.khid.toString(),
            ownphone: localStorage.getItem('username')
          }
          idatas.push(idata)
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/paddgprice',
          method: 'post',
          data: idatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '已批量保存价格'
              })
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        console.log(idatas)
      },
      getSpanData (data) {
        // 存放计算好的合并单元格的规则
        this.spanData = []
        for (var z = 0; z < this.specgroupsdata.length; z++) {
          var tmpdata = []
          for (var i = 0; i < data.length; i++) {
            if (i === 0) {
              tmpdata.push(1)
              this.pos = 0
            } else {
              // 判断当前元素与上一个元素是否相同
              console.log('判断两个元素是否相同')
              if (data[i]['col' + z] === data[i - 1]['col' + z]) {
                tmpdata[this.pos] += 1
                tmpdata.push(0)
              } else {
                tmpdata.push(1)
                this.pos = i
              }
            }
          }
          this.spanData.push(tmpdata)
        }
      },
      objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
        for (var z = 0; z < this.specgroupsdata.length; z++) {
          if (columnIndex === z) {
            const _row = this.spanData[z][rowIndex]
            const _col = _row > 0 ? 1 : 0
            return {
              rowspan: _row,
              colspan: _col
            }
          }
        }
      },
      preattr () {
        that.$emit('preattr');
      },
      nextimg () {
        that.$emit('nextimg');
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
  function doExchange (arr) {
    var len = arr.length
    if (len >= 2) {
      // 第一个数组的长度
      var len1 = arr[0].length
      // 第二个数组的长度
      var len2 = arr[1].length
      // 2个数组产生的组合数
      var lenBoth = len1 * len2
      //  申明一个新数组,做数据暂存
      var items = new Array(lenBoth)
      // 申明新数组的索引
      var index = 0
      // 2层嵌套循环,将组合放到新数组中
      for (var i = 0; i < len1; i++) {
        for (var j = 0; j < len2; j++) {
          /*
          if (arr[0][i] instanceof Array) {
            items[index] = arr[0][i].concat(arr[1][j]);
          } else {
            items[index] = [arr[0][i]].concat(arr[1][j]);
          }
          index++;
           */
           items[index] = arr[0][i] + ',' + arr[1][j]
           index++
        }
      }
      // 将新组合的数组并到原数组中
      var newArr = new Array(len - 1)
      for (var k = 2; k < arr.length; k++) {
        newArr[k - 1] = arr[k]
      }
      newArr[0] = items
      console.log('本层结束')
      var tmparr = newArr
      console.log(tmparr)
      // 执行回调
      return doExchange(newArr)
    } else {
      return arr[0]
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/MSpecs.vue